module.exports = __webpack_public_path__ + "static/img/west-city1.d11e65e7.png";